/** Extended-data key `createDocument` sets from the organization's pallet-sscc flag. */
export const PALLET_SSCC_DOCUMENT_FLAG = '_palletSscc';

/** The products-table variables that exist only for an organization with pallet-sscc on. */
export const PALLET_SSCC_VARIABLES: readonly string[] = ['palletNumber', 'sscc'];

export const isPalletSsccDocument = (globalOptions: unknown): boolean =>
  typeof globalOptions === 'object' &&
  globalOptions !== null &&
  PALLET_SSCC_DOCUMENT_FLAG in globalOptions &&
  globalOptions[PALLET_SSCC_DOCUMENT_FLAG] === true;

export type DefinitionNode = { label: string; children?: Record<string, DefinitionNode> };

export function omitPalletSsccVariables(definitionMap: Record<string, DefinitionNode>): Record<string, DefinitionNode> {
  const kept: Record<string, DefinitionNode> = {};

  for (const [variable, node] of Object.entries(definitionMap)) {
    if (PALLET_SSCC_VARIABLES.includes(variable)) continue;
    kept[variable] = node.children ? { ...node, children: omitPalletSsccVariables(node.children) } : node;
  }

  return kept;
}
